import { setItem } from "@helpers/helpers";
import { STORAGE_KEY } from "@constants/constants";
import { createSlice } from "@reduxjs/toolkit";
import { loginUser } from "../services/login-services";

export const loginInitialValues = {
  username: "",
  password: "",
};

const initialState = {
  login: loginInitialValues,
  isAuthenticated: false,
  error: null,
  loading: false,
  responseMessage: null,
  errorMessage: null,
};

export const loginSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    resetSuccess(state) {
      state.responseMessage = null;
    },
    resetError(state) {
      state.errorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        if (action.payload?.data?.item) {
          const token = JSON.stringify(action.payload?.data?.item?.token);
          // const permissions = JSON.stringify(
          //   action.payload?.data?.item?.permissions
          // );
          const user = JSON.stringify(action.payload?.data?.item?.user);
          localStorage.setItem(STORAGE_KEY.LOGIN_STATE, "1");
          setItem(STORAGE_KEY.TOKEN, token);
          // setItem(STORAGE_KEY.PERMISSIONS, permissions);
          setItem(STORAGE_KEY.USER, user);
        }
        state.error = null;
        state.isAuthenticated = true;
        state.responseMessage = action.payload.message || "Login successfully";
        state.loading = false;
      })
      .addCase(loginUser.rejected, (state, action) => {

        state.errorMessage = action.payload?.message || action.error.message;

        state.loading = false;
      });
  },
});
export const { resetSuccess,resetError} = loginSlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export const loginAuth = (state) => state.loginAuth;
export default loginSlice.reducer;
